<template>

  <v-card color="white" class="card-border">
    <v-system-bar height="45" window color="itoviGrayLight">
      <h2 class="card-header-text">Payment Information</h2>
      <v-spacer />
    </v-system-bar>

    <div v-if="!!ccInfo">
      <CreditCardDialog />
      <BillingHistoryDialog v-if="showBillingHistoryDialog" v-model="showBillingHistoryDialog" :history="billingHistory" />
    </div>

    <div v-if="!(!!ccInfo)" class="pa-4">
      <v-progress-linear :indeterminate="true" />
    </div>
    <div class="card-body" v-if="!!ccInfo">


      <!-- CC info               -->
      <v-layout align-center row wrap>
        <span class="txt-bold">Card Info</span>
        <v-spacer />
        <v-btn small flat color="accent" class="txt-bold"
               @click="openCcDialog()">Update
        </v-btn>
      </v-layout>
      <div v-if="!ccInfo.last_four">No card on file</div>

      <div v-if="ccInfo.last_four">Card ending in {{ ccInfo.last_four}}</div>
      <div v-if="ccInfo.exp">Expires {{ ccInfo.exp}}</div>

      <div class="mt-3 mb-3" v-if="declinedPayment" >
        <v-layout class="itoviHold--text" style="font-weight: bold;"><img src="../../../assets/invalid_icon.svg" class="mb-1 mr-2" height="20" width="20"/>Card Invaild</v-layout>
        <div style="font-size: 12px" v-if="this.isExpired()">Card is expired, update your card info</div>
        <div style="font-size: 12px" v-else-if="this.isExpiringSoon()">Card is expiring soon, update your card info</div>
      </div>

      <v-divider class="mt-4 mb-3" />


      <!-- Billing History               -->
      <v-layout align-center row wrap>
        <span class="txt-bold">Billing History</span>
        <v-spacer />
        <v-btn small flat color="accent" class="txt-bold"
               @click="showBillingHistoryDialog = true">View
        </v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
  import api from "../../../services/api_endpoints";
  import store from '../../../store'
  import moment from "moment"
  import CreditCardDialog from "./CreditCardDialog"
  import BillingHistoryDialog from "./BillingHistoryDialog"
  import subscribeToStore from "@/mixins/subscribeToStore";
  import ccHelper from "@/mixins/ccHelper";

  export default {
    components: {
      CreditCardDialog,
      BillingHistoryDialog,
    },
    data: ()=> ({
      ccInfo: store.state.ccInfo,
      declinedPayment: store.state.declinedPayment,
      showBillingHistoryDialog: false,
      billingHistory: store.state.billingHistory
    }),
    props: {
      onLoaded: Function,
    },
    mixins: [subscribeToStore, ccHelper],
    created(){
      this.fetchData()
    },
    mounted() {
      this.subscribeToStore(['ccInfo', 'billingHistory', 'declinedPayment'])
    },
    methods: {
      openCcDialog() {
        this.$store.commit('setShowUpdateCcDialog',true)
      },
      moment: function (dateString, format) {
        return moment(dateString,format);
      },
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchData() {
        await api.getCcInfo()
        await api.getBillingHistory()
        if (this.isFunction(this.onLoaded)) this.onLoaded()
      },
    },
  }
</script>
